import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    // If icon is passed directly (component)
    if (typeof icon === 'function') {
      IconComponent = icon;
    } 
    // If name string is passed
    else if (name) {
      // Handle both "FiName" and "Name" inputs
      const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
      IconComponent = FiIcons[iconName];
    }
  } catch (e) {
    IconComponent = null;
  }
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;